<template>
  <div class="profile-view">
    <div class="profile-area">
      <div class="profile-pic">
        <img :src="picturePath" alt="C'est moi!">
      </div>
      <div class="greeting-and-name">
        Hi! I'm David Han
      </div>
      <div class="self-proclamation">
        developer, outdoor enthusiast, beer nerd
      </div>
    </div>
    <div class="self-description">
      <p>I'm a software developer that focuses on helping companies 
      by building their backend systems, integrating with external
      services, and creating proof of concepts to challenge what
      they think is possible.</p>
      <p>I work mainly with the .NET framework, specifically C#, but
      am just as enthusiastic about databases and frontend 
      technologies.</p>
      <p>I am currently working at a digital design bureau called
      Visual Art, where I championed the adoption of the VueJS framework and 
      am now pushing for developing our mobile presence with the use of NativeScript.</p>
      <p>Do you have an interesting project in mind? I like solving
      problems and to build things; why don't you contact me 
      and lets see if I can help you?</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      picturePath: './static/DavidHanProfilePic_resize.jpg'
    }
  }
}
</script>



<style lang="scss" scoped>

$breakpoints_threshold_minus1: 767px;
$breakpoints_threshold: 768px;

$component-max-height: 90%;
$component-max-width: 100%;

$section-height: 100%;
$section-width: 40%;

.profile-view {

  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.25);
  background-color: #1A1A1A;


  @media only screen and (max-width: $breakpoints_threshold_minus1) {
    height: 100%;
    width: 100%;

    display: inline-block;
    margin: 0 auto;
  }
  @media only screen and (min-width: $breakpoints_threshold) {
    height: $component-max-height;
    width: $component-max-width;

    display: flex;
    justify-content: space-around;
    align-content: space-around;
  }

  

  .profile-area {



    @media only screen and (max-width: $breakpoints_threshold_minus1) {
      display: inline-block;
      height: $section-height;
      width: $section-width;

      padding-top: 50%;
    }
    @media only screen and (min-width: $breakpoints_threshold) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: $section-height;
      width: $section-width;
    }

    .profile-pic img {
      max-height:80%; 
      max-width:80%; 
      border-radius: 50%;
    }

    .greeting-and-name {
      font-size: 36px;
    }

    .self-proclamation {
      font-size: 15px;
    }
  }

  .self-description {


    @media only screen and (max-width: $breakpoints_threshold_minus1) {
      display: block;
      height: $section-height;
      padding: 20% 20%;
      background-color: #1A1A1A;
    }
    @media only screen and (min-width: $breakpoints_threshold) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: $section-height;
      width: $section-width;
    }

    font-size: 12px;

    text-align: left;
  }
}
</style>




// WEBPACK FOOTER //
// src/page/Profile.vue